import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { DEFAULTS } from '../../../../../ship-from/components/ship-from-dropdown/constants';
import { ValidationPropType } from '../../../../../ship-from/components/ship-from-dropdown/prop-types';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../../../../../store/csw/csw.fulfillment-plan-to-csw';
import ShipFromDropdownRenderer from '../../../../../fulfillment-planner/ship-from/ship-from-dropdown-renderer';
import ShipFromLabel from '../../../../../fulfillment-planner/ship-from/label';

import style from './style.module.less';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const ShipFromDropdown = ({
  shipFroms = emptyArray,
  validation = DEFAULTS.validation,
  onShipFromSelected = noop,
  selectedShipFromId = '',
  setModel = noop,
  bulkUpdateJobId = '',
  model = emptyObject,
}) => {
  const shipFromWithNames = useMemo(() => shipFroms.map((s) => ({ id: s.shipFromId, name: s.name })), [shipFroms]);

  useEffect(() => {
    const isExternalFulfillment = selectedShipFromId?.includes(EXTERNAL_SHIP_FROM_PREFIX);

    if (isExternalFulfillment) {
      setModel(bulkUpdateJobId, {
        ...model,
        externalFulfillmentConfiguration: {
          ...model?.externalFulfillmentConfiguration,
          sellerFulfillmentProviderId: selectedShipFromId,
        },
      });
      return;
    }
    setModel(bulkUpdateJobId, {
      ...model,
      shippingConfiguration: {
        ...model?.shippingConfiguration,
        shipFromId: selectedShipFromId,
      },
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={style['bulk-ship-from']}>
      <div className={style['ship-from-input-label']}>
        <ShipFromLabel />
      </div>
      <ShipFromDropdownRenderer
        onChange={onShipFromSelected}
        selectedShipFromId={selectedShipFromId}
        shipFroms={shipFromWithNames}
        validation={validation}
      />
    </div>
  );
};

ShipFromDropdown.propTypes = {
  bulkUpdateJobId: PropTypes.string,
  model: PropTypes.object,
  onShipFromSelected: PropTypes.func,
  selectedShipFromId: PropTypes.string,
  setModel: PropTypes.func,
  shipFroms: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      shipFromId: PropTypes.string,
    }),
  ),
  validation: ValidationPropType,
};
